<template>
	<router-view></router-view>
</template>

<script>
// test24
// test hyeonbin
// test dongeon
// import HelloWorld from './components/HelloWorld.vue'
export default {
	name: 'App',
	data() {
		return {
			test: process.env.VUE_APP_TEST,
		};
	},
	components: {
		// HelloWorld
	},
};
</script>

<style>
</style>
